import { render, staticRenderFns } from "./FeatureCard.vue?vue&type=template&id=6a80d4c8&scoped=true"
import script from "./FeatureCard.vue?vue&type=script&lang=ts"
export * from "./FeatureCard.vue?vue&type=script&lang=ts"
import style0 from "./FeatureCard.vue?vue&type=style&index=0&id=6a80d4c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a80d4c8",
  null
  
)

export default component.exports